import { checkboxClasses, SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import { useContext } from 'react';
import { useSearchParams } from 'react-router-dom';

import Checkbox from '~components/Checkbox/Checkbox';
import { Invoice } from '~hooks/useInvoices/models';
import { TabQSParam } from '~pages/Approvals/DriverPay/TabQSParam';
import DriverPayPageContext from '~pages/Approvals/DriverPayV2/DriverPayPageContext';
import { hasActionsForInvoice } from '~pages/Approvals/DriverPayV2/utils';
interface CheckboxColumnProps {
  invoice: Invoice;
  sx?: SxProps<Theme>;
}

export default function CheckboxColumn({ invoice, sx }: CheckboxColumnProps) {
  const { getInvoiceCheckedState, toggleInvoiceCheck } = useContext(DriverPayPageContext);
  const [searchParams] = useSearchParams();

  const isChecked = getInvoiceCheckedState(invoice);
  const showCheckbox = hasActionsForInvoice(
    invoice,
    searchParams.get('tab') as TabQSParam,
  );

  return (
    <Box sx={sx}>
      {showCheckbox && (
        <Checkbox
          isChecked={isChecked}
          onChange={() => toggleInvoiceCheck(invoice)}
          sx={{ [`&.${checkboxClasses.root}`]: { mt: '-10px' } }}
        />
      )}
    </Box>
  );
}
